import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

import { StyledDropdownContent } from "app/pages/workspace/sales/components/custom-dropdown/DropdownContent/styles";

const DIVIDER_STYLES = css`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
`;

export const StyledFooterContainer = styled.div<{ isHideFooterDivider?: boolean }>`
    ${({ isHideFooterDivider }) => (isHideFooterDivider ? "" : DIVIDER_STYLES)}
    margin-left: 8px;
    margin-right: 8px;
`;

export const StyledItemsContainer = styled.div`
    padding-bottom: 8px;
    padding-top: 8px;
`;

export const StyledContent = styled(StyledDropdownContent)`
    box-shadow: 0 2px 16px ${rgba(colorsPalettes.black["0"], 0.21)};
    width: 320px;
    z-index: 10;
`;

export const StyledDDContainer = styled.div`
    position: relative;
    user-select: none;
`;
